'use strict';

import opt from './options';
import log from './logger';

const eventListeners = {};

export default {on, off, trigger};

function on(event, fn) {
    eventListeners[event] = eventListeners[event] || [];
    eventListeners[event].push(fn);
    return this;
}

function off(event, fn) {
    const listeners = eventListeners[event];

    if (listeners) {
        const index = listeners.indexOf(fn);

        if (index !== -1) {
            listeners.splice(index, 1);
        }
    }
    return this;
}

function trigger(event, data = {}) {
    const eventNamespaces = event.split('.');
    const name = eventNamespaces[0];
    const listeners = eventNamespaces.reduce((arr, namespace, index) => {
        return arr.concat(eventListeners[eventNamespaces.slice(0, index + 1).join('.')] || []);
    }, []);

    data.name = name;
    data.type = eventNamespaces.length > 1 ? eventNamespaces[1] : null;
    data.subtype = eventNamespaces.length > 2 ? eventNamespaces[2] : null;

    log.debug(`event triggered ${event}`, data);

    if (listeners) {
        listeners.forEach((listener) => listener(data));
    }

    // backward compatible
    if (event === 'beforeBootstrap' && opt.onBeforeBootstrap) {
        opt.onBeforeBootstrap(data.fragment);
    } else if (event === 'afterBootstrap' && opt.onAfterBootstrap) {
        opt.onAfterBootstrap(data.fragment);
    }
    return this;
}
